import { render, staticRenderFns } from "./BridgeErrorStep.vue?vue&type=template&id=e2a6de50&scoped=true"
import script from "./BridgeErrorStep.vue?vue&type=script&lang=ts"
export * from "./BridgeErrorStep.vue?vue&type=script&lang=ts"
import style0 from "./BridgeErrorStep.vue?vue&type=style&index=0&id=e2a6de50&prod&lang=scss"
import style1 from "./BridgeErrorStep.vue?vue&type=style&index=1&id=e2a6de50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a6de50",
  null
  
)

export default component.exports